import Files from '../../../../api/Files'
import UploadLines from '../../../../components/Sales/Enquiries/AddEnquiry/UploadLines'
import moment from 'moment'
import omitEmpty from 'omit-empty'
import React, { Component } from 'react'
import { message, Select } from 'antd'
import { omit, pick } from 'lodash'
import Transactions from '../../../../api/Finance/Transactions'
import { withRouter } from 'react-router-dom'
import { idMaker } from '../../../../modules/Utils'
import XLSX from 'xlsx'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'

const ids = idMaker()
const filesApi = new Files()

class UploadLinesCont extends Component {
  state = {
    transactionUploadList: [],
    selection: [],
    current: 0,
    list: [],
    details: {},
    BankSelectCmp: Select,
    enquiry: this.props.enquiry,
  }
  fileReader = new FileReader()
  api = new Transactions()
  transactionUploadFormRef = React.createRef()
  mapCsvFields = (list, details) => {
    console.log({ details })
    let rows = []
    list.SheetNames.forEach(function (sheetName) {
      let XL_row_object = XLSX.utils.sheet_to_json(list.Sheets[sheetName])
      const lines = XL_row_object.map((line, i) => {
        let key = ids.next().value
        let d = {}

        console.log(55, line)
        switch (details.template) {
          case 'CLP':
            {
              d = {
                _key: key,
                _id: key,
                no: `${('000' + i).slice(-3)}`,
                ticked: i > 3 && i < XL_row_object.length - 14,
                materials: {
                  country: line['__EMPTY_6'],
                  no: `${line[Object.keys(line)[0]]}`,
                  oem: {
                    name: line['__EMPTY_4'],
                    no: line['__EMPTY_5'],
                  },
                },
                unit: line['__EMPTY_3'],
                description: line['__EMPTY_2'],
                name: ` ${line['__EMPTY_1']}`,
                uom: { code: line['__EMPTY_4'] },

                category: {
                  code: 'mroMaterials',
                  name: 'Materials',
                  type: 'MRO',
                  _id: 'productCategories/10333995117196',
                  _key: '10333995117196',
                  _rev: '_YcGjvL---_',
                },

                enquiry: details.enquiry,
                delivery: {
                  address: { label: line['__EMPTY_14'] },
                },
                rep: {
                  fn: line['__EMPTY_12'],
                  email: { label: line['__EMPTY_13'] },
                },
              }
            }
            break
          case 'EM_IQ':
            {
              d = {
                _key: key,
                _id: key,
                no: `${('000' + i).slice(-3)}`,
                ticked: i > 0 && i < XL_row_object.length,
                materials: {
                  country: line['__EMPTY_13'],
                  no: `${line[Object.keys(line)[3]]}`,
                  oem: {
                    name: line['__EMPTY_6'],
                    no: line['__EMPTY_8'],
                  },
                  clientRef: String(line['__EMPTY']),
                },
                unit: line['__EMPTY_4'],
                description: line['__EMPTY_7'],
                name: ` ${line['__EMPTY_3']}`,
                uom: { code: line['__EMPTY_5'] },

                category: {
                  code: 'mroMaterials',
                  name: 'Materials',
                  type: 'MRO',
                  _id: 'productCategories/10333995117196',
                  _key: '10333995117196',
                  _rev: '_YcGjvL---_',
                },

                enquiry: details.enquiry,
                /*delivery: {
                address: { label: line['__EMPTY_14'] },
              },*/
                /* rep: {
                fn: line['__EMPTY_12'],
                email: { label: line['__EMPTY_13'] },
              },*/
              }
            }
            break
        }

        console.log(333, d);
        return {
          ...d,
          uploaded: line,
        }
      })
      rows.push(...lines)
    })
    return rows
  }
  checkTransactionUploadForm = () => {
    return new Promise((res) => {
      this.transactionUploadFormRef.current.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.setState({ fetching: true })
            const { transactionUploadList } = this.state
            values.enquiry = this.props.enquiry
            const list = this.mapCsvFields(transactionUploadList, values)
            this.setState({
              list: list,
              toUploadList: list,
              selection: list.filter((t) => t.ticked).map((t) => t._key),
              details: values,
              fetching: false,
            })
            res(values)
          } catch (e) {
            console.error(e)
            this.setState({ fetching: false })
            message.error(e.errorMessage || 'Error in CSV')
          }
        }
      })
    })
  }
  onShowTransactionUpload = () => {
    this.setState({
      visibleTransactionUpload: true,
    })
  }
  onCancelTransactionUpload = () => {
    this.setState({
      visibleTransactionUpload: false,
      transactionUploadList: [],
      csvFileList: [],
    })
  }
  onFileLoadEnd = async () => {
    try {
      const content = this.fileReader.result
      const transactionUploadList = XLSX.read(content, {
        type: 'binary',
      })
      this.setState({
        transactionUploadList,
      })
    } catch (e) {
      message.error(e.errorMessage || 'Error Converting the XLSX file')
    }
  }
  onFileLoaded = async ({ file }) => {
    try {
      this.fileReader.onloadend = this.onFileLoadEnd
      if (file) {
        await this.fileReader.readAsBinaryString(file)
      }
    } catch (e) {
      message.error('Error Reading the file.')
    }
  }
  beforeUpload = (file) => {
    this.setState({
      csvFileList: [file],
    })
    return false
  }

  prev = () => {
    const current = this.state.current - 1
    this.setState({ current })
  }
  next = async () => {
    let valid = false
    switch (this.state.current) {
      case 0:
        valid = await this.checkTransactionUploadForm()
        break
      default:
        valid = true
    }
    if (valid) {
      const current = this.state.current + 1
      this.setState({ current })
    }
  }

  submit = async () => {
    try {
      this.setState({
        submitting: true,
      })
      let data = this.state.selection.map((s, i) => {
        let line = omit(
          this.state.toUploadList.find((t) => t._key === s),
          ['_id', '_key', 'ticked', 'no']
        )
        line.no = `${('00' + (i + 1)).slice(-2)}`
        line.enquiry = pick(line.enquiry, ['_id', 'code', 'title'])
        return line
      })

      const formData = new FormData()
      this.state.csvFileList.forEach((file) => {
        formData.append('upload', file)
      })
      const fdata = {
        meta: JSON.stringify(
          omitEmpty({
            folder: `${this.props.enquiry._id}`,
            timestamp: moment().utc().format(),
            name: 'Upload CSV File',
            description: 'CSV File Used To Auto Create Enquiry Liens',
            email: false,
            category: 'Enquiry',
          })
        ),
      }
      for (let name in fdata) {
        formData.append(name, fdata[name])
      }

      let file = await filesApi.upload(formData)
      await EnquiriesApi.uploadCSV(data)
      this.setState({
        submitting: false,
      })
      message.success('Uploaded!')
      await this.props.fetchLines()
      await this.props.hideModal()
    } catch (e) {
      message.error(e)
      this.setState({
        submitting: false,
      })
    }
  }
  toggleSelection = (key) => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)]
    } else {
      selection.push(key)
    }
    this.setState({ selection })
  }
  toggleAll = () => {
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      const wrappedInstance = this.formRef.current.getWrappedInstance()
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach((item) => {
        selection.push(item._original._id)
      })
    }
    this.setState({ selectAll, selection })
  }
  isSelected = (key) => {
    return this.state.selection.includes(key)
  }

  render() {
    return (
      <UploadLines
        {...this.state}
        {...pick(this, [
          'onTransactionUpload',
          'onChangeCompany',
          'checkTransactionUploadForm',
          'onShowTransactionUpload',
          'onCancelTransactionUpload',
          'onFileLoadEnd',
          'onFileLoaded',
          'beforeUpload',
          'transactionUploadFormRef',
          'prev',
          'next',
          'submit',
          'toggleSelection',
          'toggleAll',
          'isSelected',
        ])}
      />
    )
  }
}

UploadLinesCont.propTypes = {}
UploadLinesCont.defaultProps = {}

export default withRouter(UploadLinesCont)
